import {IntegrationCard, IntegrationSectionHeader, IntegrationDeleteDialog} from '../IntegrationDesign';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Tooltip, IconButton} from "@mui/material";
import Spinner from "../../../spinner/Spinner";
import {DeleteOutlined, EditOutlined} from "@mui/icons-material";
import React, {useState} from "react";

function AffiliateNetworkIntegrations(props) {

    const {deleteIntegration, integration, history, location, clear} = props;

    const [prompt, setPrompt] = useState(false);
    const [deleteIntegrationId, setDeleteIntegrationId] = useState(0);

    const edit = (rowData) => {

        clear();

        if (rowData?.networkType === "sedo") {
            history.push({
                pathname: "/settings/integrations/sedo/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "system1") {
            history.push({
                pathname: "/settings/integrations/system1/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "tonic") {
            history.push({
                pathname: "/settings/integrations/tonic/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "ads-com") {
            history.push({
                pathname: "/settings/integrations/ads-com/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "shopify") {
            history.push({
                pathname: "/settings/integrations/shopify/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
    };

    const addIntegration = () => {
        props.history.push({
            pathname: "/settings/integrations/add-affiliate-network",
            state: {background: props.location}
        });
    };

    const handleDeletePrompt = (id) => {
        setDeleteIntegrationId(id);
        setPrompt(true);
    };

    const handleDeleteIntegration = (prompt) => {
        if (!prompt) {
            setPrompt(false);
            return false;
        } else {
            deleteIntegration(deleteIntegrationId);
            setPrompt(false);
        }
    };

    return (
        <Box sx={{minWidth: 0}}>
            <IntegrationCard elevation={0}>
                {integration?.loading?.affiliateNetworkIntegrations && <Spinner overComponentBox={true}/>}
                <IntegrationSectionHeader title="Revenue sync · Affiliate networks" description="Sync revenue and conversions from your affiliate partners." onAdd={addIntegration}
                    count={integration?.loading?.affiliateNetworkIntegrations ? undefined : integration?.affiliateNetworkIntegrations?.length}/>

                {prompt && <IntegrationDeleteDialog question="Delete integration?" text={`Remove "${integration?.affiliateNetworkIntegrations?.find(row => row.id === deleteIntegrationId)?.networkName || 'this integration'}" from Skro?`} confirm={handleDeleteIntegration}/>
                }

                <TableContainer sx={{maxHeight: "400px"}}>
                    <Table stickyHeader size="small" aria-label="affiliate-network-integrations">
                        <TableHead sx={{whiteSpace: "nowrap"}}>
                            <TableRow hover>
                                <TableCell>Network Name</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{whiteSpace: "nowrap"}}>
                            {integration?.affiliateNetworkIntegrations?.map((row) => (
                                <TableRow key={row?.id}>
                                    <TableCell sx={{width: "100%"}}>{row?.networkName}</TableCell>
                                    <TableCell>
                                        <Box display="flex" flexWrap="nowrap" alignItems="center"
                                             justifyContent="right">
                                            <Box mr={1}>
                                                <Tooltip title="Edit">
                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        color="inherit"
                                                        onClick={() => edit(row)}
                                                        aria-label="edit"
                                                    >
                                                        <EditOutlined fontSize="small" color="inherit"/>
                                                    </IconButton>
                                                </span>
                                                </Tooltip>
                                            </Box>
                                            <Box>
                                                <Tooltip title="Delete">
                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        color="inherit"
                                                        onClick={() => handleDeletePrompt(row?.id)}
                                                        aria-label="delete"
                                                    >
                                                        <DeleteOutlined fontSize="small" color="error"/>
                                                    </IconButton>
                                                </span>
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </IntegrationCard>
        </Box>
    );

}

export default AffiliateNetworkIntegrations;
